import {
  API_BASE_URL,
  clearAuthTokens,
  decodeJwtPayload,
  getAuthToken,
  getRefreshToken,
  refreshAccessToken,
  setAuthTokens
} from './apiClient.ts';

export const authProvider = {
  login: async ({ username, password }: { username: string; password: string }) => {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ username, password })
    });

    if (!response.ok) {
      throw new Error('Invalid username or password');
    }

    const data = (await response.json()) as {
      access_token?: string;
      refresh_token?: string;
    };
    if (!data.access_token || !data.refresh_token) {
      throw new Error('Auth tokens missing');
    }

    setAuthTokens(data.access_token, data.refresh_token);
  },
  logout: () => {
    clearAuthTokens();
    return Promise.resolve();
  },
  checkAuth: () => {
    const token = getAuthToken();
    const refreshToken = getRefreshToken();
    if (!token && !refreshToken) {
      return Promise.reject();
    }

    if (!token && refreshToken) {
      return refreshAccessToken().then((newToken) =>
        newToken ? Promise.resolve() : Promise.reject()
      );
    }

    if (!token) {
      return Promise.reject();
    }

    const payload = decodeJwtPayload(token);
    if (payload?.exp && payload.exp * 1000 < Date.now()) {
      return refreshAccessToken().then((newToken) =>
        newToken ? Promise.resolve() : Promise.reject()
      );
    }

    return Promise.resolve();
  },
  checkError: (error: { status?: number }) => {
    if (error?.status === 401 || error?.status === 403) {
      return refreshAccessToken().then((newToken) =>
        newToken ? Promise.resolve() : Promise.reject()
      );
    }
    return Promise.resolve();
  },
  getPermissions: () => Promise.resolve()
};
